
import React from 'react';
import { LinearProgress, Grid, CircularProgress } from '@material-ui/core';

const SomaStatus = (props) => {
    const { children, status, ...rest } = props;
    const states = {
        waitComponent:
            <CircularProgress variant="indeterminate" color='primary' />,
        wait:
            <LinearProgress  variant="query" color="primary" />,
        empty:
            <Grid container justify="center" alignItems="center" style={{ marginTop: "10vh" }} direction="column">
                <span style={{ fontSize: "700%", fontFamily: "flama-medium", fontWeight: "900", color:"#707070", textShadow: "1px 0px #707070, 9px 0px #E4D3C7" }}> Oooops</span>
                <span style={{ fontSize: "150%", fontFamily: "flama-medium", fontWeight: "bolder", color:'#707070' }}> Sem resultados pra essa busca :( </span>
            </Grid>,
        error:
            <Grid container justify="center" direction="column" alignItems="center" style={{ marginTop: "10vh" }}>
                <Grid item>
                    <span item style={{ fontSize: "600%", fontFamily: "flama-medium", fontWeight: "900", color:"#707070", textShadow: "1px 0px #707070, 9px 0px #E4D3C7", whiteSpace: "nowrap" }}> Deu <span role="img" aria-label="zebra">🦓</span></span>
                </Grid>
                <Grid item style={{ fontSize: "150%", fontFamily: "flama-medium", fontWeight: "bolder" }}>
                    Ocorreu um erro inesperado.
                </Grid>
                <Grid item style={{ fontSize: "150%", fontFamily: "flama-medium", fontWeight: "bolder" }}>
                    Tente novamente mais tarde!
                </Grid>
            </Grid>,
        result: children,
        ...rest
    }
    return states[status] || null;
}
export default SomaStatus

